import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';

import Contact from '../contact/Contact';
import ClientLogos from '../clientlogos/ClientLogos';

const Services = ({ showBreadcrumbs = true, showExtras = true }) =>{
  // 1. Call AOS.init() in a useEffect so it runs on mount
  useEffect(() => {
    AOS.init({
      duration: 1000,   // Animation duration in milliseconds
      offset: 50,       // Offset (in px) from the original trigger point
      easing: 'ease-in-out',
      once: false       // Whether animation should happen only once
    });
  }, []);

  const services = [
    { img: "./assets/images/service-design.svg", title: "Web & App Design", desc: "We craft visually stunning and user-friendly applications that enhance user experience and drive engagement." },
    { img: "./assets/images/service-hosting.svg", title: "Web Hosting", desc: " Reliable and secure web hosting solutions to ensure maximum uptime and fast website performance." },
    { img: "./assets/images/service-social.svg", title: "Social Media Management", desc: "Enhance your brand’s online presence with our expert social media strategies and targeted marketing campaigns." },
    { img: "./assets/images/service-seo.svg", title: "SEO Optimization", desc: "Improve search rankings and drive organic traffic with our result-driven SEO strategies." },
    { img: "./assets/images/service-cloud.svg", title: "Cloud Solutions", desc: "Scalable and secure cloud hosting solutions for enhanced performance and data accessibility." },
    { img: "./assets/images/service-secure.svg", title: "Data Security", desc: " Protect your business data with advanced security protocols, encryption, and backup solutions." }
  ];

  return (
    
    <>
      {/* Conditionally render Breadcrumbs */}
      {showBreadcrumbs && (
        <Breadcrumbs
           pageTitle="Our Services"
           pageSubtitle="We provide user-friendly software solutions that are usually flexible, scalable, and responsive for all platforms."
          activePage="Services"
        />
      )}
    
    <div className="services" id="services">
      <div className="col-md-12">
        <div className="header" data-aos="fade-up" data-aos-delay="100">
          <div className="col-md-8 col-lg-6 col-xl-5 mx-auto px-3">
            <div className="title">What We Do</div>
            <p className="para">
              We provide web solutions, including web design, development, and WordPress customization,
              to help businesses establish a strong online presence.
            </p>
          </div>
        </div>

        <div className="container">
          {services.map((service, index) => (
            <div className="bg-white"
              key={index}
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)} // Increase delay per item
            >
              <img src={service.img} alt={service.title} />
              <h4>{service.title}</h4>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    {/* Conditional Rendering: Show ClientLogos and Contact only when showExtras is true */}
    {showExtras && (
        <>
          <ClientLogos />
          <Contact />
        </>
      )}
    </>
  );
};

export default Services;
